import { Check, Copy01 } from "@untitledui/icons";
import { useClipboard } from "@/hooks/use-clipboard";
import { useToast } from "@/providers/toast-provider";
import type { CopyFieldProps } from "../types";

const CopyField = ({ value, label }: CopyFieldProps) => {
	const { showToast } = useToast();
	const { copied, copy } = useClipboard();

	if (!value) {
		return null;
	}

	const handleCopy = async () => {
		const { success } = await copy(value);

		if (success) {
			showToast({ title: "Copiado!", variant: "success" });
		} else {
			showToast({ title: "Erro ao copiar", variant: "error" });
		}
	};

	return (
		<div className="flex flex-col gap-1.5">
			{label ? (
				<span className="font-medium text-gray-700 text-sm">{label}</span>
			) : null}

			<div className="flex items-center overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xs">
				<span className="flex-1 select-all truncate px-3 py-2 text-gray-500 text-sm">
					{value}
				</span>

				<button
					className="flex items-center justify-center border-gray-200 border-l px-3 py-2.5 transition hover:bg-gray-50"
					onClick={handleCopy}
					type="button"
				>
					{copied ? (
						<Check className="h-4 w-4 text-green-500" />
					) : (
						<Copy01 className="h-4 w-4 text-gray-400" />
					)}
				</button>
			</div>
		</div>
	);
};
export default CopyField;
